export default {
    install() {
        // version.json is generated only on build
        if (process.env.NODE_ENV === 'development') return

        const checkVersionInterval = 10 * 60 * 1000 // 10 minutes

        // Check version from package.json
        const packageJson = require('../../package.json')
        const currentVersion = packageJson.version

        const fetchAndCheckVersion = async () => {
            try {
                fetch('/version.json')
                    .then(response => response.json())
                    .then(data => {
                        if (!data || !data.version) {
                            return
                        }

                        const newVersion = data.version

                        if (newVersion && currentVersion && currentVersion !== newVersion) {
                            setTimeout(() => {
                                window.location.reload()
                            }, 5 * 60 * 1000) // Reload after 2 minutes
                        }
                    })
            } catch (error) {
                console.error('Error during version check:', error)
            }
        }

        // Run the version check after the plugin is installed
        fetchAndCheckVersion()

        // Set the interval for regular version checks
        setInterval(fetchAndCheckVersion, checkVersionInterval)
    }
}